/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { CustomerAccountDeleteRequest } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * DeleteAccountApi - axios parameter creator
 * @export
 */
export const DeleteAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send the email to the lapeyre service to handle the account deletion.
         * @summary Customer account deletion
         * @param {string} storeId The store identifier.
         * @param {CustomerAccountDeleteRequest} customerAccountDeleteRequest The request object for document request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (storeId: string, customerAccountDeleteRequest: CustomerAccountDeleteRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deleteAccount', 'storeId', storeId)
            // verify required parameter 'customerAccountDeleteRequest' is not null or undefined
            assertParamExists('deleteAccount', 'customerAccountDeleteRequest', customerAccountDeleteRequest)
            const localVarPath = `/store/{storeId}/resources/usermanagement/deleteAccount`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerAccountDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeleteAccountApi - functional programming interface
 * @export
 */
export const DeleteAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeleteAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * Send the email to the lapeyre service to handle the account deletion.
         * @summary Customer account deletion
         * @param {string} storeId The store identifier.
         * @param {CustomerAccountDeleteRequest} customerAccountDeleteRequest The request object for document request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(storeId: string, customerAccountDeleteRequest: CustomerAccountDeleteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccount(storeId, customerAccountDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeleteAccountApi - factory interface
 * @export
 */
export const DeleteAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeleteAccountApiFp(configuration)
    return {
        /**
         * Send the email to the lapeyre service to handle the account deletion.
         * @summary Customer account deletion
         * @param {string} storeId The store identifier.
         * @param {CustomerAccountDeleteRequest} customerAccountDeleteRequest The request object for document request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(storeId: string, customerAccountDeleteRequest: CustomerAccountDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAccount(storeId, customerAccountDeleteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeleteAccountApi - object-oriented interface
 * @export
 * @class DeleteAccountApi
 * @extends {BaseAPI}
 */
export class DeleteAccountApi extends BaseAPI {
    /**
     * Send the email to the lapeyre service to handle the account deletion.
     * @summary Customer account deletion
     * @param {string} storeId The store identifier.
     * @param {CustomerAccountDeleteRequest} customerAccountDeleteRequest The request object for document request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteAccountApi
     */
    public deleteAccount(storeId: string, customerAccountDeleteRequest: CustomerAccountDeleteRequest, options?: any) {
        return DeleteAccountApiFp(this.configuration).deleteAccount(storeId, customerAccountDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
